export const ESTIMATE = 'estimate_modal'

export const estimate = {
  en: {
    translation: {
      [ESTIMATE]: {
        type: 'Type',
        trade: 'Trade',
        vendorGL: 'Name',
        totalAmount: 'Total Amount',
        transactionStatus: 'Estimate Status',
        markAs: 'Mark as',
        paidBackDate: 'Paid Back',
        newEstimate: 'New Estimate',
        submit: 'Submit',
        approvedBy: 'Approved By',
        paymentType: 'Payment Type',
        transactionType: 'Estimate Type',
        against: 'Against',
        changeOrder: 'Change Order',
        workOrder: 'Work Order',
        paymentTerm: 'Payment Term',
        newExpectedCompletionDate: 'New Expected Completion',
        expectedCompletion: 'Expected Completion',
        paymentReceivedDate: 'Payment Received',
        paidDate: 'Paid Date',
        payDateVariance: 'Pay Date Variance',
        invoicedDate: 'Invoiced Date',
        scanningMessage: 'Scanning Attachment. This may take few seconds...',
        woPaymentDate: 'Payment Date',
        confirmationTitle: 'Are you sure?',
        confirmationMessageMaterialAttachment:
          'Do you really want to upload a new attachment? Current line item(s) will be replaced with the scanned items from the new receipt, as you Save the transaction.',

        // Estimate Modal
        addNewRow: 'Add New Row',
        newRow: 'New Row',
        deleteRow: 'Delete Row',
        attachment: 'Attachment',
        dateCreated: 'Date Created',
        createdBy: 'Created By',
        contact: 'Contact',
        dateModified: 'Date Modified',
        modifiedBy: 'Modified By',
        description: 'Description',
        amount: 'Amount',
        total: 'Total',
        status: 'Status',
        close: 'Close',
        save: 'Save',
        next: 'Next',
        back: 'Back',
        cancel: 'Cancel',
        nameofClaimant: 'Name of Claimant',
        jobLocation: 'Job Location',
        makerOfCheck: 'Maker of Check',
        amountOfCheck: 'Amount of Check $',
        claimantsTitle: "Claimant's Title",
        claimantsSignature: 'Claimant’s Signature',
        dateOfSignature: 'Date of signature',
        readMore: 'Read More',
        readLess: 'Read Less',
        refund: 'Refund',

        // Project WO Overview Table
        vendor: 'Vendor',
        clientApprovedAmount: 'Client Approved Amount',
        finalClientApprovedAmount: 'Final Client Approved Amount',
        originalVendorWO: 'Original Vendor WO',
        revisedVendorWO: 'Revised Vendor WO',
        COs: 'COs',
        revisedCOs: 'Revised COs',
        finalVendorWOs: 'Final Vendor WOs',
        draws: 'Draws',
        materials: 'Materials',
        percentagePaid: '% Paid',
        invoicedAmount: 'Invoiced Amount',
        balance: 'Balance',
        profit: 'Profit',
        profitPercentage: 'Profit %',
        factoring: 'Factoring',
        lateFee: 'Late Fee',

        // Financial Overview Table
        client: 'Client',
        originalSOWAmount: 'Original SOW Amount',
        revisedSOWAmount: 'Revised SOW Amount',
        adjustment: 'Adjustment for SOW',
        finalSOWAmount: 'Final SOW Amount',
        partialPayments: 'Partial Payments',
        AR: 'AR',
        workOrderIdTransTable: 'Work Order ID',
      },
    },
  },
  es: {
    translation: {
      [ESTIMATE]: {
        type: 'Escribe',
        vendorGL: 'Nombre',
        transactionStatus: 'Estimate Status',
        updateEstimate: 'Actualizar estimate',
        newEstimate: 'Nueva Transacción',
        newWorkOrder: 'Nueva Orden de Trabajo',
        newDocument: 'Nuevo Documento',
        newAlert: 'Nueva Alerta',
        transaction: 'Transacción',
        vendorWorkOrders: 'Órdenes de Trabajo del Proveedor',
        documents: 'Documentos',
        alerts: 'Alertas',
        upload: 'Subir',
        uploadDocument: 'Subir documento',
        contactName: 'Nombre de Contacto',
        projectID: 'Projecto ID',
        contactNo: 'Número de Contacto',
        WODueDate: 'Fecha de vencimiento de OT',
        DueDateWO: 'Fecha de vencimiento OT',
        trade: 'Comercio',
        auditLogs: 'Registros de auditoría',
        totalAmount: 'Cantidad Total',
        submit: 'Entregar',
        approvedBy: 'Aprobado Por',
        paymentType: 'Tipo de Pago',
        transactionType: 'Tipo de estimate',
        against: 'Estatuto',
        changeOrder: 'Cambia el Orden',
        workOrder: 'Orden de Trabajo',
        paymentTerm: 'Plazo de Pago',
        newExpectedCompletionDate: 'Nueva Fecha de Finalización Prevista',
        expectedCompletion: 'Expected Completion',
        paymentReceivedDate: 'Pago Recibido',
        invoicedDate: 'Fecha Facturada',
        paidDate: 'Fecha de Pago',
        payDateVariance: 'Variación de La Fecha de Pago',
        scanningMessage: 'Adjunto de escaneo. Esto puede tardar unos segundos...',
        woPaymentDate: 'Fecha de pago',
        confirmationTitle: 'Estas segura?',
        confirmationMessageMaterialAttachment:
          'Realmente desea cargar un nuevo archivo adjunto? Los elementos de línea actuales se reemplazarán con los elementos escaneados del nuevo recibo, a medida que guarde la estimate.',

        // Estimate Modal

        addNewRow: 'Añadir Nueva Fila',
        newRow: 'Fila nueva',
        deleteRow: 'Borrar Fila',
        attachment: 'Adjunto Archivo',
        dateCreated: 'Fecha de Creacion',
        createdBy: 'Creado por',
        contact: 'Contacto',
        dateModified: 'Fecha Modificada',
        modifiedBy: 'Modificado Por',
        description: 'Descripción',
        amount: 'Monto',
        total: 'Total',
        status: 'Estado',
        close: 'Cerca',
        save: 'Ahorrar',
        next: 'Siguiente',
        back: 'Espalda',
        cancel: 'Cancelar',
        markAs: 'Marcar como',
        paidBackDate: 'Pagado',
        nameofClaimant: 'Nombre del reclamante',
        jobLocation: 'locación de trabajo',
        makerOfCheck: 'fabricante de cheque',
        amountOfCheck: 'Monto del cheque $',
        claimantsTitle: 'Título del reclamante',
        claimantsSignature: 'Firma del reclamante',
        dateOfSignature: 'Fecha de la firma',
        readMore: 'Lee mas',
        readLess: 'Leer menos',
        refund: 'Reembolso',

        // Project WO Overview Table
        vendor: 'Vendedor',
        clientApprovedAmount: 'Monto aprobado por el cliente',
        finalClientApprovedAmount: 'Cantidad final aprobada por el cliente',
        originalVendorWO: 'Proveedor original WO',
        revisedVendorWO: 'Proveedor revisado WO',
        COs: 'COs',
        revisedCOs: 'CO Revisados',
        finalVendorWOs: 'WOs Vendedor final',
        draws: 'Sorteos',
        materials: 'Materiales',
        percentagePaid: '% Payé',
        invoicedAmount: 'Importe facturado',
        balance: 'Balance',
        profit: 'Lucro',
        profitPercentage: 'Lucros %',
        factoring: 'Factorización',
        lateFee: 'Cargo por demora',

        // Financial Overview Table
        client: 'Cliente',
        originalSOWAmount: 'Importe original de la SOW',
        revisedSOWAmount: 'Cantidad SOW revisada',
        adjustment: 'Ajuste por SOW',
        finalSOWAmount: 'Importe de la SOW final',
        partialPayments: 'Pagos Parciales',
        AR: 'AR',
        workOrderIdTransTable: 'ID de orden de trabajo',
      },
    },
  },
}
